import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 46px 32px 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  ${({ theme }) => theme.max("sm")`
    padding: 2rem 0rem;
  `}
`;

export const Logo = styled.img`
  margin-bottom: 80px;
  width: 196px;
`;

export const Title = styled.span`
  color: var(--Oxford-blue, #06203A);
  font-family: Inter;
  font-size: 23px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 3px;
`;

export const Text = styled.span`
  color: var(--Oxford-blue, #06203A);
  font-family: Inter;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 50px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: var(--Placeholder, #A3A3A3);
  font-family: Inter;
  font-size: 12px;
  line-height: 24px;
  display: flex;
  align-items: center;
  gap: 6px;
  
  &:hover {
    color: #666;
  }
`;

export const Footer = styled.div`
  margin-top: 52px;
  text-align: center;
`;

export const MistakeText = styled.span`
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  text-transform: capitalize;
`;

export const UndoLink = styled.button`
  color: var(--Denim, #1271A6);
  background: none;
  border: none;
  padding: 0;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  text-transform: capitalize;
`;
